// extracted by mini-css-extract-plugin
export default {"loadingContainer":"Loading_loadingContainer__Sxkpu","mainContainer":"Loading_mainContainer__0u2kF","spinner":"Loading_spinner__vI8Mo"};